import { useEffect } from 'react'
import { useRouter } from 'next/router'

// Constants
import { STORAGE_DATA } from '@/constants/storageData'
import { ROUTE_PATH } from '@/constants/routePath'

const AUTHORIZATION_PATH = [ROUTE_PATH.ORDERS, ROUTE_PATH.ORDER_RESULT, ROUTE_PATH.ME, ROUTE_PATH.MY_LIVE_FUTURE, ROUTE_PATH.MY_LIVE_PAST]

export const useAuthorization = () => {
  const router = useRouter()
  const { pathname, asPath } = router

  useEffect(() => {
    if (typeof window === 'undefined') return

    const tokenFromLocalStorage = JSON.parse(<string>window.localStorage.getItem(STORAGE_DATA.TOKEN))

    const isAuthorizationPath = AUTHORIZATION_PATH.includes(pathname)

    // v2：未登入進受保護頁，導去站內 /login（該頁提供 v2 表單，也保留舊會員的 passport 入口），帶上原頁供登入後導回
    if (!tokenFromLocalStorage && isAuthorizationPath) {
      router.replace(`${ROUTE_PATH.LOGIN}?redirect=${encodeURIComponent(asPath)}`)
    }
  }, [pathname])
}
